import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouteStateService {
  constructor(private router: Router) {}

  /**
   * 轉址
   *
   * @param path 轉導路徑
   * @param data 參數
   */
  navigateTo(url: string, queryParams?: { [key: string]: any }): void {
    let httpParams = new HttpParams();

    Object.entries(queryParams ?? {}).forEach(([key, value]) => {
      httpParams = httpParams.set(key, value?.toString() ?? '');
    });

    const formatUrl = httpParams.keys().length
      ? `${url}?${httpParams.toString()}`
      : url;

    if (this.router.url === formatUrl) {
      // 在原頁面時，先跳轉至 / 再跳轉回原路徑
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigateByUrl(formatUrl));
    } else {
      this.router.navigateByUrl(formatUrl);
    }
  }
}
